import { Injectable } from '@angular/core';
import { CalendarRepository } from '../../repositories/calendar.respository';
import { Observable } from 'rxjs';
import { ServiceResponse } from 'src/app/@shared/interfaces/service-response.interface';
import { RouteCalendarAtStop } from '../../interfaces/route-planning/gtfs/route-calendar-at-stop.interface';
import { TripStopTime, TripStopTimeSourceDestination } from '../../interfaces/route-planning/gtfs/trip-stop-time.interface';
import { NextDayOfService } from '../../interfaces/route-planning/gtfs/next-day-of-service.interface';

@Injectable({
  providedIn: 'root',
})
export class CalendarService {
  constructor(private readonly calendarRepository: CalendarRepository) {}

  GetRouteDailyCalendar(model: {
    startStopId: number;
    endStopId: number;
    routeId: number;
    day: string;
  }): Observable<ServiceResponse<{ [stopId: number]: TripStopTime[] }>> {
    return this.calendarRepository.GetRouteDailyCalendar(model);
  }

  GetTripCalendar(model: {
    routeId: number;
    stopId: number;
    stopSequence: number;
    dayPassingAtStop: number;
    timePassingAtStop: string;
  }): Observable<ServiceResponse<{ [stopId: number]: TripStopTime[] }>> {
    return this.calendarRepository.GetTripCalendar(model);
  }

  GetRouteCalendarAtStops(model: {
    stopIds: number[];
    routeId: number;
    firstStopTime?: string;
    lastStopTime?: string;
    maximumNextStops?: number;
  }): Observable<ServiceResponse<{ [stopId: number]: RouteCalendarAtStop }>> {
    return this.calendarRepository.GetRouteCalendarAtStops(model);
  }

  GetRouteCalendarAtStopsByStopCodes(model: {
    stopCodes: string[];
    routeDesc: string;
    firstStopTime?: string;
    lastStopTime?: string;
  }): Observable<ServiceResponse<{ [stopId: number]: RouteCalendarAtStop }>> {
    return this.calendarRepository.GetRouteCalendarAtStopsByStopCodes(model);
  }

  GetRouteNextDayOfService(routeId: number, day: string): Observable<ServiceResponse<NextDayOfService>> {
    return this.calendarRepository.GetRouteNextDayOfService(routeId, day);
  }

  GetTripCalendarForSourceDestination(model: {
    routeDesc: string;
    agencyId: number;
    stopCode: number;
    dateTime: string;
  }): Observable<ServiceResponse<Record<number, TripStopTimeSourceDestination[]>>> {
    return this.calendarRepository.GetTripCalendarForSourceDestination(model);
  }
}
